module.exports = __webpack_public_path__ + "static/media/SameerSawant_v1.23bea2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SameerSawant_v1.jpg
// module id = 56
// module chunks = 0